import { render } from "./FixedItemPut.vue?vue&type=template&id=527b6b9c"
import script from "./FixedItemPut.vue?vue&type=script&lang=js"
export * from "./FixedItemPut.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__